import { render, staticRenderFns } from "./premium-form-endorsement.vue?vue&type=template&id=49d21ddb&scoped=true&"
import script from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
export * from "./premium-form-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./premium-form-endorsement.vue?vue&type=style&index=0&id=49d21ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d21ddb",
  null
  
)

export default component.exports